import { isDevelopment } from '@config/config';

export const API_URL = '/api';

export const ADMIN_URL = isDevelopment
  ? 'http://poseidon.pfz.localhost'
  : 'https://admin.qa-pfz.com';

export const CONTACT_EMAIL = 'responsabilidade@parafuzo.com';
